export default __webpack_public_path__ + "static/media/ENTREVISTA-AMILTON.28abebe9.png";